import React from 'react';
import styles from '../styles/Copyright.module.css';

const Copyright: React.FC = () => {
  return (
    <div className="footer">
      <div className={styles.separator}></div>
      <p className={styles.copyright}>&copy; 2024 Split Heritage</p>
    </div>
  );
};

export default Copyright;